import { render, staticRenderFns } from "./TextToImage.vue?vue&type=template&id=3a921bc8&"
import script from "./TextToImage.vue?vue&type=script&lang=js&"
export * from "./TextToImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports